module.exports = __webpack_public_path__ + "img/bg_zww.3e26a650.svg";